import _ from 'common-tools/LodashHelper'
import { FormData, FormValues, FormState, FormNames, FormErrors } from './State/ReduxFormState'
import { AppState } from './State/AppStateState'
import { SessionToken, SessionAccount, SessionSettings, SessionUser, SessionDeviceFingerPrint } from './State/CurrentSessionState'
import { DrawerSizes, DrawerList } from './State/DrawerState'
import { LayoutContentSearch, LayoutContentMenus, LayoutContentBreadCrumbKeys } from './State/LayoutContentState'
import { CurrentRouteInfo, IndexRoutes } from './State/ReduxRouterState'

const helperFunctions = {
  SessionToken: SessionToken,
  SessionUser: SessionUser,
  SessionAccount: SessionAccount,
  SessionSettings: SessionSettings,
  SessionDeviceFingerPrint: SessionDeviceFingerPrint,
  DrawerSizes: DrawerSizes,
  DrawerList: DrawerList,
  CurrentRouteInfo: CurrentRouteInfo,
  LayoutContentSearch: LayoutContentSearch,
  LayoutContentMenus: LayoutContentMenus,
  LayoutContentBreadCrumbKeys: LayoutContentBreadCrumbKeys,
  IndexRoutes: IndexRoutes,
  FormNames: FormNames
}

export const sh = {
  SessionToken: 'SessionToken',
  SessionUser: 'SessionUser',
  SessionAccount: 'SessionAccount',
  SessionSettings: 'SessionSettings',
  SessionDeviceFingerPrint: 'SessionDeviceFingerPrint',
  DrawerSizes: 'DrawerSizes',
  DrawerList: 'DrawerList',
  LayoutContentSearch: 'LayoutContentSearch',
  LayoutContentMenus: 'LayoutContentMenus',
  LayoutContentBreadCrumbKeys: 'LayoutContentBreadCrumbKeys',
  CurrentRouteInfo: 'CurrentRouteInfo',
  IndexRoutes: 'IndexRoutes',
  FormValues: FormValues,
  FormData: FormData,
  FormState: FormState,
  FormNames: 'FormNames',
  FormErrors: FormErrors,
  AppState: AppState
}

export const buildState = (sh, custom) => {
  return (state) => {
    let stateProps = {}
    if (_.isFunction(custom)) {
      stateProps = _.merge(stateProps, custom(state) || {})
    }
    _.forEach(sh, (h) => {
      if (_.isFunction(h)) {
        let sData = h(state)
        _.forEach(_.keys(sData), (fd) => {
          stateProps[fd] = sData[fd]
        })
      } else {
        stateProps[h] = helperFunctions[h](state)
      }
    })
    return stateProps
  }
}
